import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import UpdatingSpinner from "../ui/UpdatingSpinner";
import { addLocation, setShowLocationModal } from "../plugins/plugin.redux";
import * as serialize from "form-serialize";

const labelStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};
const modalStyle = {
  borderBottom: "transparent",
};
const bodyStyle = {
  borderBottom: "transparent",
  padding: "0rem 1rem 1rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const formStyle = {
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "column",
};

const doubleButtonStyle = {
  width: "30px",
  height: "100%",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const inputStyle = {
  width: "100%",
  height: "30px",
};
const colStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
  margin: "0.2em 0",
};

const rowStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  flexDirection: "column",
};

const rowContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const ModalRedux = (props) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const { showLocationModal, setShowLocationModal, addLocation, adding } =
    props;

  const handleClose = () => {
    setShowLocationModal({ showLocationModal: false });
  };

  const handleAdd = () => {
    const form = formRef.current;
    const values = serialize(form, { hash: true });
    const location = {
      ...values,
    };
    addLocation({ location });
    handleClose();
  };

  return (
    <>
      <Modal
        size="sm"
        show={showLocationModal}
        onHide={handleClose}
        centered
        className={`select-modal jobService`}
      >
        <Modal.Header closeButton style={modalStyle}>
          <span style={labelStyle}>
            <span style={{ marginRight: 5 }}>{t(`jobBoard.addLocation`)}</span>
          </span>
        </Modal.Header>
        {adding ? (
          <Modal.Body style={bodyStyle}>
            <UpdatingSpinner />
          </Modal.Body>
        ) : (
          <Modal.Body style={bodyStyle}>
            <Form ref={formRef}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
                style={formStyle}
              >
                <div className="row" style={rowContainerStyle}>
                  <div className="col-10">
                    <div className="row" style={rowStyle}>
                      <div className="col-12" style={colStyle}>
                        {t(`jobBoard.LocationName`)}:
                      </div>
                      <div className="col-12" style={{ padding: 0 }}>
                        <Form.Control
                          type="text"
                          placeholder=""
                          autoFocus
                          style={inputStyle}
                          name="name"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-2"
                    style={{
                      height: 107,
                      padding: 0,
                      paddingLeft: 3,
                      paddingTop: 23,
                    }}
                  >
                    <Button onClick={handleAdd} style={doubleButtonStyle}>
                      <FontAwesomeIcon icon={["fas", "arrow-down"]} />
                    </Button>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export const ModalLocation = connect(
  (state) => {
    return {
      adding: state.plugin.adding,
      showLocationModal: state.plugin.showLocationModal,
    };
  },
  {
    addLocation,
    setShowLocationModal,
  }
)(ModalRedux);
